import {useEffect, useRef} from 'react';

import {useAccessToken, useCommerceApi} from '@salesforce/commerce-sdk-react';

import {trackViewCartFromBasket} from '@amblique/king-living/app/analytics/ga4/view-cart';

/** Fire GA4 `view_cart` once per cart flyout open (basket line IDs only; master fetched in tracker). */
export const useViewCartOnFlyoutOpen = ({
  basket,
  currency,
  customer,
  isBasketLoading,
  isOpen,
}) => {
  const api = useCommerceApi();
  const {getTokenWhenReady} = useAccessToken();
  const viewCartTrackedRef = useRef(false);
  const basketRef = useRef(basket);

  basketRef.current = basket;

  useEffect(() => {
    if (!isOpen) {
      viewCartTrackedRef.current = false;

      return;
    }

    if (isBasketLoading || viewCartTrackedRef.current) {
      return;
    }

    if ((basketRef.current?.productItems?.length ?? 0) > 0 && !api?.shopperProducts) {
      return;
    }

    viewCartTrackedRef.current = true;

    void trackViewCartFromBasket({
      api,
      basket: basketRef.current,
      currency,
      customer,
      getToken: getTokenWhenReady,
    });
  }, [api, currency, customer, getTokenWhenReady, isBasketLoading, isOpen]);
};
